import { LogoutIcon } from 'components/svg-icons/logout';

import React from 'react';
// eslint-disable-next-line no-restricted-imports -- TODO: legacy styled-components (baseline)
import styled from 'styled-components/macro';

const IconContainer = styled.div`
    height: 20px;
    margin-right: 10px;

    cursor: pointer;

    &:hover {
        color: var(--uiPrimaryColor);
    }
`;

export const BackToAdminLink = props => (
    <IconContainer onClick={props.onClick}>
        <LogoutIcon />
    </IconContainer>
);
